module.exports = __webpack_public_path__ + "static/media/LK_White_Add User.aebcc4bf.svg";